import React from 'react';
import { History, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const VersionHistory = () => {
  return (
    <div className="page-container">
      {/* Header Section */}
      <div className="page-header">
        <Link 
          to="/collaboration/documents" 
          className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Document Library
        </Link>
        <h1 className="page-title">Version History</h1>
        <p className="page-subtitle">
          Track document changes and maintain complete history.
        </p>
      </div>

      {/* Main Content */}
      <div className="page-content">
        <div className="card">
          <div className="card-body">
            <div className="text-center py-12">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '20px',
                  background: '#8b5cf620',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 24px'
                }}
              >
                <History size={48} style={{ color: '#8b5cf6' }} />
              </div>
              
              <h2 style={{ 
                fontSize: '24px', 
                fontWeight: '700', 
                color: '#1f2937',
                marginBottom: '16px',
                fontFamily: 'var(--font-family)'
              }}>
                Document Versioning
              </h2>
              
              <p style={{ 
                color: '#6b7280', 
                fontSize: '16px', 
                marginBottom: '32px',
                lineHeight: '1.6',
                maxWidth: '600px',
                margin: '0 auto 32px'
              }}>
                Complete document version history with change tracking and rollback capabilities. 
                This feature will be available in v1.1.
              </p>
              
              <div style={{
                background: '#fef3c7',
                border: '1px solid #f59e0b',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '24px',
                maxWidth: '600px',
                margin: '0 auto 24px'
              }}>
                <p style={{ 
                  color: '#92400e', 
                  fontSize: '14px',
                  margin: '0',
                  fontWeight: '500'
                }}>
                  <strong>Coming Soon:</strong> Advanced version control with change tracking, 
                  rollback capabilities, and collaborative editing history.
                </p>
              </div>

              <button 
                style={{
                  background: '#8b5cf6',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0 auto',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.background = '#7c3aed'}
                onMouseOut={(e) => e.target.style.background = '#8b5cf6'}
              >
                <History size={20} style={{ marginRight: '8px' }} />
                View History
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionHistory;
